import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../../lib/shared/validators";

export const paymentStatus = v.union(
  v.literal("pending"),
  v.literal("partial"),
  v.literal("completed"),
  v.literal("cancelled"),
  v.literal("failed"),
  v.literal("reversed"),
);

export const paymentMethods = v.union(
  v.literal("credit_card"),
  v.literal("paypal"),
  v.literal("bank_transfer"),
  v.literal("cash"),
  v.literal("other"),
);

export const validatorInvoicePayment = v.object({
  clientId: v.id("clients"),
  saleId: v.optional(v.id("sales")),
  invoiceId: v.optional(v.id("invoices")),
  status: v.optional(paymentStatus),
  amount: v.number(),
  reversedAt: v.optional(v.number()),
  reversalReason: v.optional(v.string()),
  paymentMethod: paymentMethods,
  internalControl: v.optional(internalControl),
});

export const invoices_payments = defineTable(validatorInvoicePayment)
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_invoice_id", ["invoiceId"])
  .index("by_sale_id", ["saleId"])
  .index("by_payment_method", ["paymentMethod"])
  .index("by_client_id", ["clientId"])
  .index("by_status", ["status"])
  .index("by_company_and_status", ["internalControl.companyId", "status"])
  .index("by_company_and_branch", [
    "internalControl.companyId",
    "internalControl.branchId",
  ]);
